<template>
	<div class="zoom-control">
		<button
			:disabled="value == maxZoom || disabled"
			name="zoom-in"
			aria-label="zoom in"
			mousedown.prevent
			:class="{ 'skip-disable': isTutorial }"
			@click="zoomIn"
		>
			<svgicon name="zoomin"></svgicon>
		</button>
		<button
			:disabled="value == minZoom || disabled"
			name="zoom-out"
			class="mb--4"
			aria-label="zoom out"
			mousedown.prevent
			:class="{ 'skip-disable': isTutorial }"
			@click="zoomOut"
		>
			<svgicon name="zoomout"></svgicon>
		</button>
		<button
			v-if="isAutoLoanButtonVisible"
			:disabled="isAutoLoanDisabled"
			name="auto-loan"
			aria-label="auto loan"
			@click="openLoan(AUTO_LOAN)"
		>
			<svgicon name="expenseCategories/auto-loan-transportation"></svgicon>
		</button>
		<button
			v-if="isMortgageLoanVisible"
			:disabled="isMortgageLoanDisabled"
			name="mortgage-loan"
			aria-label="mortgage loan"
			@click="openLoan(MORTGAGE_LOAN)"
		>
			<svgicon name="expenseCategories/mortgage-loan"></svgicon>
		</button>
	</div>
</template>
<script>
import '../icons/zoomin';
import '../icons/zoomout';
import { applicationLoanTypes } from '@/helpers/constants';
export default {
	props: {
		value: {
			type: Number,
			required: true
		},
		maxZoom: {
			type: Number,
			required: true
		},
		minZoom: {
			type: Number,
			required: true
		},
		isTutorial: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			AUTO_LOAN: applicationLoanTypes.AUTO_LOAN,
			MORTGAGE_LOAN: applicationLoanTypes.MORTGAGE_LOAN
		};
	},
	computed: {
		isAutoLoanButtonVisible() {
			return this.$store.getters.isAutoLoanDealershipVisible;
		},
		isMortgageLoanVisible() {
			return this.$store.getters.isMortgageLoanVisible;
		},
		isAutoLoanDisabled() {
			return (
				!this.$store.getters.isInBudgetingPhase &&
				!this.$store.getters.isAutoLoanApplied
			);
		},
		isMortgageLoanDisabled() {
			return (
				!this.$store.getters.isInBudgetingPhase &&
				!this.$store.getters.isMortgageLoanApplied
			);
		}
	},
	methods: {
		zoomIn() {
			this.$emit('zoomedIn');
		},
		zoomOut() {
			this.$emit('zoomedOut');
		},
		openLoan(loanType) {
			this.$emit(`openLoan`, this.$store.getters[loanType]);
		}
	}
};
</script>
<style lang="scss" scoped>
.zoom-control {
	display: flex;
	flex-direction: column;
	z-index: 8;
	position: absolute;

	button {
		touch-action: manipulation;
		height: 52px;
		width: 52px;
		border-radius: 100%;
		border: 1px solid $container-border;
		background-color: $container-bgcolor;
		padding: 0;
		box-shadow: 0px 15px 30px 0 rgba(0, 76, 208, 0.35);
		margin-bottom: 12px;

		svg {
			fill: $primary-state;
			height: 24px;
			width: 24px;
		}

		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		&:active {
			outline: 0;
			color: $tapped-state;
		}

		&:disabled {
			svg {
				fill: $disabled-state;
			}
		}
	}
}
</style>
